<template>
  <form
    id="group-form"
    @submit="checkForm"
    action="#"
    method="post"
    novalidate="true"
  >
    <div class="form-item">
      <label class="required" for="group-name">{{
        $t("plan.groupForm.modal.text.groupName")
      }}</label>
      <p v-if="errGroupName && groupName.length > 30" class="error">
        {{ $t("plan.groupForm.errorMsg.groupName") }}
      </p>
      <p v-if="errSurrogatePair" class="error">
        {{ $t("plan.groupForm.errorMsg.surrogatePair") }}
      </p>
      <input
        id="group-name"
        name="group-name"
        maxlength="30"
        v-model="groupName"
        v-on:input="
          updateForm = true;
          invalidGroupName = false;
          errGroupName = false;
          errSurrogatePair = false;
        "
        v-bind:class="{
          error: errGroupName || errSurrogatePair || invalidGroupName,
        }"
      />
      <p v-if="errGroupName" class="error errorMsg">
        {{ $t("plan.groupForm.errorMsg.noGroupName") }}
      </p>
      <p v-if="invalidGroupName" class="error errorMsg">
        {{ $t("plan.groupForm.errorMsg.invalidGroupName") }}
      </p>
      <span v-bind:class="{ 'char-count': true, error: groupName.length > 30 }">
        {{ groupName.length }} / 30
      </span>
    </div>

    <div class="form-item">
      <label class="" for="group-summary">{{
        $t("plan.groupForm.modal.text.groupSummary")
      }}</label>
      <p v-if="errGroupSummary && groupSummary.length > 300" class="error">
        {{ $t("plan.groupForm.errorMsg.groupSummary") }}
      </p>
      <textarea
        id="group-summary"
        name="group-summary"
        rows="4"
        maxlength="300"
        v-model="groupSummary"
        v-on:input="updateForm = true"
        v-bind:class="{ error: errGroupSummary }"
      ></textarea>
      <span
        v-bind:class="{ 'char-count': true, error: groupSummary.length > 300 }"
      >
        {{ groupSummary.length }} / 300
      </span>
    </div>

    <input
      type="submit"
      class="submit"
      v-bind:value="$t('plan.groupForm.modal.button')"
    />
  </form>
</template>

<script>
import { validSurrogatePair } from "@/utils/validSurrogatePair";
import { validFileInclusion } from "@/utils/validFileInclusion";
import { planService } from "@/services/plan.service";

export default {
  props: ["planId"],
  name: "GroupForm",
  data() {
    //let user = JSON.parse(localStorage.getItem('user'))
    return {
      invalidForm: true,
      invalidGroupName: false,

      errGroupName: false,
      errSurrogatePair: false,
      errGroupSummary: false,

      groupName: "",
      groupSummary: "",
    };
  },
  /*created: function () {
    console.log('planid from form: ', this.planId)
  },*/
  methods: {
    checkForm: function(event) {
      this.invalidForm = false;
      this.errGroupName = false;
      this.errSurrogatePair = false;
      this.errGroupSummary = false;

      if (this.groupName === "") {
        this.invalidForm = true;
        this.errGroupName = true;
      }

      if (this.groupName.length > 30 || validFileInclusion(this.groupName)) {
        this.invalidForm = true;
        this.invalidGroupName = true;
      }

      if (validSurrogatePair(this.groupName)) {
        this.invalidForm = true;
        this.errSurrogatePair = true;
      }

      if (this.groupSummary.length > 300) {
        this.invalidForm = true;
        this.errGroupSummary = true;
      }

      if (!this.invalidForm) {
        this.createGroup();
      }

      event.preventDefault();
    },
    createGroup: function() {
      let newGroup = {
        description: btoa(encodeURIComponent(this.groupSummary)),
        name: this.groupName,
        enabled: true,
        meterActive: false,
      };

      planService
        .createGroup(this.planId, newGroup)
        .then((res) => {
          console.log("called group create ", res);
          this.$router.go(0);
        })
        .catch((err) => {
          console.error("Something went wrong: ", err);
        });
    },
  },
};
</script>
<style lang="scss">
.modal-body {
  color: $text-dark;
  padding: 40px 40px 0;

  #group-form {
    padding: 20px 0;
  }
}

#group-form {
  .form-item {
    position: relative;
    .char-count {
      position: absolute;
      right: 0;
      bottom: 5px;
    }
  }

  input.submit {
    @extend button;
    margin-top: 0;
    width: auto;
  }
  .auth-req {
    margin-top: 15px;
    padding-top: 30px;
    border-top: 2px solid #ccc;
  }
}
.errorMsg {
  margin-top: -20px;
}
</style>
